import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiAndroid,
  DiApple,
  DiMysql,
  DiJava,
  DiSwift
} from "react-icons/di";
import {
  SiPytorch,
  SiFirebase,
  SiKotlin,
  SiFlutter,
  SiDart,
  SiTensorflow,
  SiOnnx,
  SiOpenai,
  SiHuggingface,
} from "react-icons/si";

function TechIcon({ icon: Icon, name }) {
  return (
    <Col xs={4} md={2} className="tech-icons">
      <div className="tech-icon-wrap" data-name={name}>
        <Icon />
      </div>
    </Col>
  );
}

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <TechIcon icon={DiAndroid}     name="Android" />
      <TechIcon icon={DiApple}       name="Apple / iOS" />
      <TechIcon icon={DiMysql}       name="MySQL" />
      <TechIcon icon={SiKotlin}      name="Kotlin" />
      <TechIcon icon={DiJava}        name="Java" />
      <TechIcon icon={DiSwift}       name="Swift" />
      <TechIcon icon={DiJavascript1} name="JavaScript" />
      <TechIcon icon={DiNodejs}      name="Node.js" />
      <TechIcon icon={DiReact}       name="React" />
      <TechIcon icon={DiMongodb}     name="MongoDB" />
      <TechIcon icon={DiGit}         name="Git" />
      <TechIcon icon={SiFirebase}    name="Firebase" />
      <TechIcon icon={DiPython}      name="Python" />
      <TechIcon icon={SiPytorch}     name="PyTorch" />
      <TechIcon icon={SiTensorflow}  name="TensorFlow" />
      <TechIcon icon={SiOnnx}        name="ONNX" />
      <TechIcon icon={SiOpenai}      name="OpenAI" />
      <TechIcon icon={SiHuggingface} name="HuggingFace" />
      <TechIcon icon={SiFlutter}     name="Flutter" />
      <TechIcon icon={SiDart}        name="Dart" />
    </Row>
  );
}

export default Techstack;
